package components.finishingUp

import it.neckar.commons.kotlin.js.getNotNull
import it.neckar.commons.kotlin.js.safeGet
import it.neckar.lizergy.model.energy.ampere
import it.neckar.lizergy.model.energy.megaOhms
import it.neckar.lizergy.model.energy.ohms
import it.neckar.lizergy.model.energy.volts
import it.neckar.lizergy.model.stumps.AssemblyRoof
import it.neckar.react.common.*
import it.neckar.react.common.form.*
import it.neckar.uuid.withReplaced
import react.*
import react.dom.*

val EditStringMessdaten: FC<EditStringMessdatenProps> = fc("EditStringMessdaten") { props ->
  val stringMessdaten = props::stringMessdaten.getNotNull()
  val stringMessdatenSetter = props::stringMessdatenSetter.getNotNull()
  val editableStatus = props::editableStatus.safeGet()

  val stringBezeichnung = useState(stringMessdaten.stringBezeichnung)
  val anzahlOptimierer = useState(stringMessdaten.anzahlOptimierer)
  val stringSpannungDachmontage = useState(stringMessdaten.stringSpannungDachmontage?.volts)
  val stringSpannungInbetriebnahme = useState(stringMessdaten.stringSpannungInbetriebnahme?.volts)
  val stringLeerlaufspannung = useState(stringMessdaten.stringLeerlaufspannung?.volts)
  val stringKurzschlussstrom = useState(stringMessdaten.stringKurzschlussstrom?.ampere)
  val isolationsWiderstand = useState(stringMessdaten.isolationsWiderstand?.megaOhms)
  val rpe = useState(stringMessdaten.rpe?.ohms)


  val stringMessdatenToSave = useMemo(
    stringBezeichnung.value,
    anzahlOptimierer.value,
    stringSpannungDachmontage.value,
    stringSpannungInbetriebnahme.value,
    stringLeerlaufspannung.value,
    stringKurzschlussstrom.value,
    isolationsWiderstand.value,
    rpe.value,
  ) {
    stringMessdaten.copy(
      stringBezeichnung = stringBezeichnung.value,
      anzahlOptimierer = anzahlOptimierer.value,
      stringSpannungDachmontage = stringSpannungDachmontage.value?.volts,
      stringSpannungInbetriebnahme = stringSpannungInbetriebnahme.value?.volts,
      stringLeerlaufspannung = stringLeerlaufspannung.value?.volts,
      stringKurzschlussstrom = stringKurzschlussstrom.value?.ampere,
      isolationsWiderstand = isolationsWiderstand.value?.megaOhms,
      rpe = rpe.value?.ohms,
    )
  }

  useEffect(stringMessdatenToSave) {
    stringMessdatenSetter {
      it.withReplaced(stringMessdatenToSave)
    }
  }


  div("row gx-0") {

    div("col-lg-3") {
      nullableFloatingInputField(
        valueAndSetter = stringBezeichnung,
        fieldName = "stringBezeichnung",
        title = "Bezeichnung",
        editableStatus = editableStatus,
      ) {
        attrs {
          mergedRight()
          mergedBelow()
        }
      }
    }

    div("col-lg-3") {
      nullableFloatingIntInputField(
        valueAndSetter = anzahlOptimierer,
        fieldName = "anzahlOptimierer",
        title = "Anzahl Optimierer",
        editableStatus = editableStatus,
      ) {
        attrs {
          mergedLeft()
          mergedRight()
          mergedBelow()
        }
      }
    }

    div("col-lg-3") {
      div("input-group") {
        nullableFloatingDoubleInputField(
          valueAndSetter = stringSpannungDachmontage,
          fieldName = "stringSpannungDachmontage",
          title = "Spannung Dachmontage",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedLeft()
            mergedRight()
            mergedBelow()
          }
        }
        span("input-group-text") {
          +"V"
        }
      }
    }

    div("col-lg-3") {
      div("input-group") {
        nullableFloatingDoubleInputField(
          valueAndSetter = stringSpannungInbetriebnahme,
          fieldName = "stringSpannungInbetriebnahme",
          title = "Spannung Inbetriebnahme",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedLeft()
            mergedBelow()
          }
        }
        span("input-group-text") {
          +"V"
        }
      }
    }

    div("col-lg-3") {
      div("input-group") {
        nullableFloatingDoubleInputField(
          valueAndSetter = stringLeerlaufspannung,
          fieldName = "stringLeerlaufspannung",
          title = "Leerlaufspannung",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedAbove()
            mergedRight()
          }
        }
        span("input-group-text") {
          +"V"
        }
      }
    }

    div("col-lg-3") {
      div("input-group") {
        nullableFloatingDoubleInputField(
          valueAndSetter = stringKurzschlussstrom,
          fieldName = "stringKurzschlussstrom",
          title = "Kurzschlussstrom",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedAbove()
            mergedLeft()
            mergedRight()
          }
        }
        span("input-group-text") {
          +"A"
        }
      }
    }

    div("col-lg-3") {
      div("input-group") {
        nullableFloatingDoubleInputField(
          valueAndSetter = isolationsWiderstand,
          fieldName = "isolationsWiderstand",
          title = "Isolations Widerstand",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedAbove()
            mergedLeft()
            mergedRight()
          }
        }
        span("input-group-text") {
          +"MΩ"
        }
      }
    }

    div("col-lg-3") {
      div("input-group") {
        nullableFloatingDoubleInputField(
          valueAndSetter = rpe,
          fieldName = "rpe",
          title = "RPE",
          editableStatus = editableStatus,
        ) {
          attrs {
            mergedAbove()
            mergedLeft()
          }
        }
        span("input-group-text") {
          +"Ω"
        }
      }
    }

  }

}

external interface EditStringMessdatenProps : Props {
  var stringMessdaten: AssemblyRoof.StringMessdaten
  var stringMessdatenSetter: StateSetter<List<AssemblyRoof.StringMessdaten>>
  var editableStatus: EditableStatus
}
